import { Bell, ClipboardList, Contact, RefreshCw, Store, UsersRound } from 'lucide-react';
import { VERTICAL_COMPARISON } from '../comparisonMatrix';
import type { LandingConfig } from '../types';

export const coachesConfig: LandingConfig = {
  slug: 'coaches',
  namespace: 'landing-coaches',
  analyticsId: 'for-coaches',
  canonicalPath: '/for-coaches',
  ogImagePath: '/images/og-coaches.jpg',
  heroImage: '/images/hero-coaches',
  // Order matches landing-coaches:features.items[]
  featureIcons: [Store, RefreshCw, Bell, ClipboardList, Contact, UsersRound],
  comparison: VERTICAL_COMPARISON,
};
